import { VisitCollector as VisitCollectorBase } from '@unitedtraders/visit-collector';
import type { Logger } from 'loglevel';
import type { PodsightsApi } from './podsightsProvider';

export class VisitCollector extends VisitCollectorBase {
  constructor(
    window: Window,
    document: Document,
    url: string,
    getGaId: () => Promise<string>,
    getUtId: () => Promise<string>,
    logger: Logger,
    podsignApi: Promise<PodsightsApi>
  ) {
    super(window, document, url, getGaId, getUtId, logger);

    if (this.getIsNewSession()) {
      podsignApi
        .then(api => {
          api.aliasWithUtClientId();
        })
        .catch(err => console.error(err));
    }
  }
}
